import { sortDates, sortMealtimes } from '../../../../../utils/dataGridSortingFunctions';
import texts from './texts.json';

const getColumns = ({
  actionsRenderCell,
  statusRenderCell,
  macroBreakDownCell,
  restrictionsRenderCell,
  mealTimesCell,
}) => [
  {
    field: ' ',
    renderCell: statusRenderCell,
    width: 20,
    align: 'center',
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: 'name',
    type: 'string',
    headerName: texts.columns.name,
    flex: 2,
    minWidth: 110,
    quickSearch: true,
  },
  {
    field: 'mealTimes',
    headerName: texts.columns.mealTimes,
    width: 85,
    renderCell: mealTimesCell,
    sortComparator: sortMealtimes('numberOfMealTimes'),

  },
  {
    field: 'meals',
    headerName: texts.columns.meals,
    width: 65,
  },
  {
    field: 'macroBreakdown',
    type: 'string',
    headerName: texts.columns.macroBreakdown,
    minWidth: 220,
    renderCell: macroBreakDownCell,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: 'allergens',
    type: 'string',
    headerName: texts.columns.allergens,
    renderCell: restrictionsRenderCell,
    minWidth: 190,
    sortable: false,
  },
  {
    field: 'lastUpdated',
    type: 'string',
    headerName: texts.columns.lastUpdated,
    width: 100,
    headerAlign: 'center',
    align: 'center',
    sortComparator: sortDates('lastUpdated'),
  },
  {
    field: 'actions',
    type: 'actions',
    headerName: texts.columns.actions,
    width: 300,
    align: 'left',
    renderCell: actionsRenderCell,
  },
];

export default getColumns;
